import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpRequestService } from '../shared/services/http-request.service';
import * as myGlobals from '../shared/globalcontants';
import { of as observableOf, Observable } from 'rxjs';
import { TransferEntity } from '../shared/models/Transactions/TransferEntity';
import { APIServiceProviderService } from '../shared/services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { RequisitionEntity } from '../shared/models/Transactions/RequisitionEntity';
import { FormGroup } from '@angular/forms';

import _ from 'lodash';
import moment from 'moment-timezone';
@Injectable({
  providedIn: 'root',
})
export class TransferService {
  public selectedItem: any;
  public isPackage = false;
  public isCopyNew = false;
  public selectedPackageItems: any = [];
  public baseUnits = ['Pounds', 'Kgs', 'Ltr'];
  public routeStack: any = ['/transfer'];
  public selectedTab: string;
  public isTransferOut = false;
  public newTransferData: any = [];
  public newTransferSelectedData: any = [];
  public isNewTransfer = false;
  public offlineIconShow = false;
  public savedTransfersTableData: any = [];
  public TransfersReqOriginalTableData: any = [];
  public savedDetailsTransfersTableData: any = [];
  public transfersFilterArray: any = [];
  public transferOfflineFilter: any = [];
  public requisitionFilterArray: any = [];
  public newTransferFilter: any = [];
  public transferSort: any;
  public requisitionSort: any;
  public transferForm: any;
  public transferEntity: TransferEntity;
  InventotyLookupData: Array<any> = [];
  public transferOrderFormData: any = [];
  public transferFormData: FormGroup;
  public savedtransferTableData: any = [];
  selectedCustomerData: string;
  selectedCustomerDetails: any;
  customerList: any;
  originalCustomerList: any = [];
  
  constructor(private _hs: HttpRequestService, private apiServiceProviderService: APIServiceProviderService) { }

  getInventoryDetails(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }

  getRecentreacheditem(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }

  getOptionArray() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson['inventoryList']);
  }

  getTransferItemDetails() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson.getTransferDetails);
  }

  getPackageItem() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson['packageItems']);
  }

  convertReqEntityToTransferEntity(requisitionEntity: RequisitionEntity): TransferEntity {

    let transferEntity: any = null;

    try {

      if (requisitionEntity && requisitionEntity.RequisitionItemDetails && requisitionEntity.RequisitionItemDetails.length > 0) {
        // transferEntity = this.apiServiceProviderService.utilityService.transfersPostInput;
        transferEntity = _.cloneDeep(this.apiServiceProviderService.utilityService.transfersPostInput);

        // Mapping Requisition Head Details Start
        // transferEntity.TransTypeId = requisitionEntity.TransTypeId;
        // transferEntity.TransferHeadDetail.InventoryHeadDetail.ReqOrTransHeaderId
        // = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.ReqOrTransHeaderId;

        transferEntity.TransferHeadDetail.InventoryHeadDetail.RefNumber
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.RefNumber;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.PostDate
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.PostDate;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.FromLocationId
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.FromLocationId;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.ToLocationId
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.ToLocationId;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.TotalAmount
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.TotalAmount;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.Remarks
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.Remarks;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.CustomerId
         = requisitionEntity.RequisitionHeaderDetail.CustomerId;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.ReqNo
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.ReqOrTransHeaderId;
        // transferEntity.CreatedBy = this.loggedInUserName;
        transferEntity.CreatedDate = moment().utc().format();
        transferEntity.TransferHeadDetail.InventoryHeadDetail.LongRemarks
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.LongRemarks;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.DebitDeptId
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.DebitDeptId;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.DataMagineNumber
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.DataMagineNumber;
        transferEntity.TransferHeadDetail.SetupHeaderDetail.Miscflag = requisitionEntity.RequisitionHeaderDetail.SetupHeaderDetail.Miscflag;
        transferEntity.TransferHeadDetail.SetupHeaderDetail.LoadedReq
        = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.ReqOrTransHeaderId;
        transferEntity.TransferHeadDetail.SetupHeaderDetail.TransToRev
         = requisitionEntity.RequisitionHeaderDetail.SetupHeaderDetail.TransToRev;
        transferEntity.TransferHeadDetail.SetupHeaderDetail.Approval = requisitionEntity.RequisitionHeaderDetail.SetupHeaderDetail.Approval;
        transferEntity.TransferHeadDetail.SetupHeaderDetail.Approver = requisitionEntity.RequisitionHeaderDetail.SetupHeaderDetail.Approver;
        transferEntity.TransferHeadDetail.SetupHeaderDetail.NextApprover
         = requisitionEntity.RequisitionHeaderDetail.SetupHeaderDetail.NextApprover;
        transferEntity.TransferHeadDetail.SetupHeaderDetail.NextApproverId
         = requisitionEntity.RequisitionHeaderDetail.SetupHeaderDetail.NextApproverId;
        transferEntity.TransferHeadDetail.SetupHeaderDetail.ApprovalStatusId
         = requisitionEntity.RequisitionHeaderDetail.SetupHeaderDetail.ApprovalStatusId;
        transferEntity.ImageId = 43223647;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.LocationDetail.LocationId
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.LocationDetail.LocationId;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.LocationDetail.SupplyLocationId
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.LocationDetail.SupplyLocationId;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.LocationDetail.LocationName
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.LocationDetail.LocationName;
        transferEntity.TransferHeadDetail.InventoryHeadDetail.LocationDetail.SupplyLocationName
         = requisitionEntity.RequisitionHeaderDetail.InventoryHeadDetail.LocationDetail.SupplyLocationName;

        // Mapping Requisition Head Details End


        // Mapping Requisition Item Details Start
        const resutlArray = requisitionEntity.RequisitionItemDetails.map(reqItemDetail => {

          const itemDetails: any = {
            ItemDetailId: 0,
            InventoryItemDetail: {},
            SelectedUnitDetail: {},
            InventoryDetail: {
              LocationDetail: {},
              InventoryOtherDetail: {},
              InventoryPeriodicDetail: {},
              SetupHeaderDetail: {},
              PictureVideoDetail: {},
              InventoryStatusByLocationDetail: {}
            },
            ReqNo: 0,
            ProductionBatch: '',
            ShippingCost: 0,
            LotNum: 0
          };

          itemDetails.ItemDetailId = reqItemDetail.ItemDetailId;

          itemDetails.InventoryDetail.Name = reqItemDetail.InventoryDetail.Name;
          itemDetails.InventoryDetail.Number = reqItemDetail.InventoryDetail.Number;
          itemDetails.InventoryDetail.Description = reqItemDetail.InventoryDetail.Description;
          itemDetails.InventoryDetail.LocationDetail.LocationName = reqItemDetail.InventoryDetail.LocationDetail.LocationName;
          itemDetails.InventoryDetail.InventoryOtherDetail.ProdRecipeId = reqItemDetail.InventoryDetail.InventoryOtherDetail.ProdRecipeId;
          itemDetails.InventoryDetail.CurrentCost = reqItemDetail.InventoryDetail.CurrentCost;
          itemDetails.InventoryDetail.InventoryPeriodicDetail.CurrentCost
          = reqItemDetail.InventoryDetail.InventoryPeriodicDetail.CurrentCost;
          itemDetails.InventoryDetail.InventoryPeriodicDetail.QuantityOnHand
           = reqItemDetail.InventoryDetail.InventoryPeriodicDetail.QuantityOnHand;
          itemDetails.InventoryDetail.SetupHeaderDetail.Quantity = reqItemDetail.InventoryDetail.SetupHeaderDetail.Quantity;
          itemDetails.InventoryDetail.InventoryOtherDetail.RevenueGrouping
           = reqItemDetail.InventoryDetail.InventoryOtherDetail.RevenueGrouping;
          itemDetails.InventoryDetail.InventoryTypeId = reqItemDetail.InventoryDetail.InventoryTypeId;
          itemDetails.InventoryDetail.InventoryId = reqItemDetail.InventoryDetail.InventoryId;
          itemDetails.InventoryItemDetail.InventoryId = reqItemDetail.InventoryItemDetail.InventoryId;
          itemDetails.InventoryDetail.InventoryClassId = reqItemDetail.InventoryDetail.InventoryClassId;
          itemDetails.InventoryDetail.SetupHeaderDetail.LinkDB = reqItemDetail.InventoryDetail.SetupHeaderDetail.LinkDB;
          itemDetails.InventoryDetail.SetupHeaderDetail.Position = reqItemDetail.InventoryDetail.SetupHeaderDetail.Position;
          itemDetails.InventoryDetail.SetupHeaderDetail.ItemId = reqItemDetail.InventoryDetail.SetupHeaderDetail.ItemId;
          itemDetails.InventoryDetail.SetupHeaderDetail.Remarks = reqItemDetail.InventoryDetail.SetupHeaderDetail.Remarks;
          itemDetails.InventoryDetail.SetupHeaderDetail.AliasRemarks = reqItemDetail.InventoryDetail.SetupHeaderDetail.AliasRemarks;
          itemDetails.InventoryDetail.SetupHeaderDetail.LocQty = reqItemDetail.InventoryDetail.InventoryStatusByLocationDetail.QtyOnHand;
          itemDetails.InventoryDetail.SetupHeaderDetail.SupplyLocQty = reqItemDetail.InventoryDetail.SetupHeaderDetail.AliasSupplyLocQty;
          itemDetails.InventoryDetail.SetupHeaderDetail.AliasSupplyLocQty = reqItemDetail.InventoryDetail.SetupHeaderDetail.SupplyLocQty;
          itemDetails.InventoryDetail.BarCode = reqItemDetail.InventoryDetail.BarCode;
          // itemDetails.InventoryDetail.PictureVideoDetail.FilePath = reqItemDetail.InventoryDetail.PictureVideoDetail.FilePath;
        //  itemDetails.InventoryItemDetail.ReqOrTransHeaderId = reqItemDetail.InventoryItemDetail.ReqOrTransHeaderId;
          itemDetails.InventoryItemDetail.TotalAmount = reqItemDetail.InventoryItemDetail.TotalAmount;
          itemDetails.InventoryItemDetail.FromLocationId = reqItemDetail.InventoryItemDetail.FromLocationId;
          itemDetails.InventoryItemDetail.ToLocationId = reqItemDetail.InventoryItemDetail.ToLocationId;
          itemDetails.InventoryItemDetail.InventoryId = reqItemDetail.InventoryItemDetail.InventoryId;
          itemDetails.InventoryItemDetail.UnitId = reqItemDetail.InventoryItemDetail.UnitId;
          itemDetails.InventoryItemDetail.Quantity = reqItemDetail.InventoryItemDetail.Quantity;
          itemDetails.InventoryItemDetail.Conversion = reqItemDetail.InventoryItemDetail.Conversion;
          itemDetails.InventoryItemDetail.Remarks = reqItemDetail.InventoryItemDetail.Remarks;
          itemDetails.InventoryItemDetail.PostDate = reqItemDetail.InventoryItemDetail.PostDate;
          itemDetails.InventoryItemDetail.InventoryTypeId = reqItemDetail.InventoryItemDetail.InventoryTypeId;
          itemDetails.InventoryDetail.UnitsDetails = reqItemDetail.InventoryDetail.UnitsDetails;
          itemDetails.ReqNo = reqItemDetail.InventoryItemDetail.ReqOrTransHeaderId;

          return itemDetails;

          // Mapping Requisition Item Details End

        });

        transferEntity.TransferItemDetails = resutlArray;
      }
    } catch (error) {
      transferEntity = null;
    }

    // if (transferEntity) {
    //
    //  transferEntity.TransferHeadDetail.InventoryHeadDetail.LocationDetail.LocationId
    // = transferEntity.InventoryItemDetail[0].FromLocationId;
    //  transferEntity.TransferHeadDetail.InventoryHeadDetail.LocationDetail.SupplyLocationId
    // = transferEntity.InventoryItemDetail[0].ToLocationId;
    // }
    return transferEntity as TransferEntity;
  }
}

